"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../../styles/theme"));
const label_1 = __importDefault(require("../label"));
const text_1 = __importDefault(require("../text"));
const input_styles_1 = require("./input-styles");
const types_1 = require("../../lib/types");
const utils_1 = require("../../lib/utils");
const TextAreaContainer = styled_components_1.default.div `
  width: ${(props) => (props.inline ? 'auto' : '100%')};
`;
const StyledTextArea = styled_components_1.default.textarea `
  ${input_styles_1.inputStyles}
  width: 100%;
  resize: none;
  font-family: ${(props) => props.theme.font.family.sans};
`;
const StyledTextAreaField = styled_components_1.default.div `
  ${input_styles_1.inputFieldStyles}
  display: flex;
  height: ${(props) => props.height};
  border-radius: 6px;
  border: 1px
    ${(props) => props.error ? props.theme.colors.error : props.theme.colors.borderDefault}
    solid;
  resize: none;
  &:focus-within {
    outline: ${(props) => props.theme.outline};
    outline-offset: 1px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.23);
  }
`;
const TextArea = ({ ariaLabel = undefined, className, disabled = false, error = false, height = '139px', hint, id, inline = false, innerRef, label = undefined, maxLength, name, onBlur = utils_1.noop, onChange = utils_1.noop, onClick = utils_1.noop, onFocus = utils_1.noop, onKeyDown = utils_1.noop, onKeyPress = utils_1.noop, onKeyUp = utils_1.noop, placeholder = '', readOnly = false, required, style, valid = false, value = undefined, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    const validStyling = valid
        ? {
            border: `1px ${theme_1.default.colors.iconLogoAccent} solid`,
        }
        : {};
    return (react_1.default.createElement(TextAreaContainer, { className: className, "data-testid": "text-area-root", inline: inline, style: style },
        label && react_1.default.createElement(label_1.default, null, label),
        react_1.default.createElement(StyledTextAreaField, { error: error, height: height, style: validStyling },
            react_1.default.createElement(StyledTextArea, { "data-testid": "text-area", "aria-label": ariaLabel || label, "aria-required": required, id: id, ref: innerRef, name: name, value: value, disabled: disabled, onChange: (event) => onChange(event.target.value, event), onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, onClick: onClick, placeholder: placeholder, readOnly: readOnly, maxLength: maxLength, required: required })),
        hint && (react_1.default.createElement(text_1.default, { fontSize: "xs", fontWeight: "normal", color: error ? theme_1.default.colors.error : theme_1.default.colors.textDefault }, hint))));
};
exports.TextArea = TextArea;
exports.default = exports.TextArea;
